export const defaultHeaderHeight = 64;

export const minHeaderHeight = 16;

export const maxHeaderHeight = 300;

export const narrowHeaderHeight = 16;
